import {
    GET_PROMOTIONAL_SIGNUP_CONTENT_REQUEST,
    GET_PROMOTIONAL_SIGNUP_CONTENT_SUCCESS,
    GET_PROMOTIONAL_SIGNUP_CONTENT_ERROR,
} from '../actionTypes/PromotionalSignUpActionTypes';

export default function PromotionalSignUpReducer(state = {}, action = {}) {
    switch (action.type) {
        case GET_PROMOTIONAL_SIGNUP_CONTENT_REQUEST: {
            const isLoading = true;
            const error = {};
            return { ...state, isLoading, error };
        }
        case GET_PROMOTIONAL_SIGNUP_CONTENT_SUCCESS: {
            const isLoading = false;
            const { data = {} } = action.payload;
            return { ...state, isLoading, ...data };
        }
        case GET_PROMOTIONAL_SIGNUP_CONTENT_ERROR: {
            const isLoading = false;
            const { error = {} } = action.payload;
            return { ...state, error, isLoading };
        }
        default:
            return state;
    }
}

PromotionalSignUpReducer.reducerName = 'promotionalSignUpReducer';
